import { render, staticRenderFns } from "./list-item.component.vue?vue&type=template&id=4152fd64&scoped=true"
import script from "./list-item.component.vue?vue&type=script&lang=js"
export * from "./list-item.component.vue?vue&type=script&lang=js"
import style0 from "./list-item.component.vue?vue&type=style&index=0&id=4152fd64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4152fd64",
  null
  
)

export default component.exports